import React, { Component } from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import * as Yup from "yup";
import { isAddress as isETHAddress } from "../../../lib/etherumAddressCheck";
import LegalCheckbox from "../../molecules/LegalCheckbox/index";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    width: "100%"
    //maxWidth: "400px"
  },
  checkboxError: {
    color: "red"
  },
  actionsContainer: {
    marginTop: theme.spacing(3)
  },
  menu: {
    width: 200
  }
});

class WalletAdressForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: null
    };

    // This binding is necessary to make `this` work in the callback
    this.handleClickNext = this.handleClickNext.bind(this);
    this.handleClickBack = this.handleClickBack.bind(this);
  }
  handleClickNext(e, form) {
    e.preventDefault();
    this.setState({ direction: "next" });
    form.submitForm();
  }
  handleClickBack(e, form) {
    e.preventDefault();
    this.setState({ direction: "back" });
    form.submitForm();
  }
  renderAllErrorMsgs(errors) {
    const listErrors = errors => {
      let elist = [];
      Object.keys(errors).forEach((key, index) => {
        elist.push(
          <Typography key={index} style={{ color: "red" }} gutterBottom>
            {errors[key]}
          </Typography>
        );
      });
      return elist;
    };
    return (
      <Grid container spacing={10}>
        <Grid item style={{ marginTop: "2em" }}>
          {listErrors(errors)}
        </Grid>
      </Grid>
    );
  }

  render() {
    const { wallet, confirmation } = this.props.data;
    const { classes } = this.props;
    return (
      <div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            wallet_address: wallet.wallet_address,
            lg02: confirmation.legal.lg03,
            lg03: confirmation.legal.lg03
          }}
          onSubmit={(values, actions) => {
            this.props.save({
              section: "wallet",
              data: {
                wallet_address: values.wallet_address
              }
            });
            this.props.save({
              section: "confirmation",
              data: {
                legal: {
                  ...confirmation.legal,
                  lg02: values.lg02,
                  lg03: values.lg03
                }
              }
            });
            if (this.state.direction === "next") {
              this.props.next();
            } else if (this.state.direction === "back") {
              this.props.back();
            }
            actions.setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            wallet_address: Yup.string().test(
              "is-eth",
              "This address is not a valid Ethereum address.",
              value => value === "er2018" || isETHAddress(value) // er2018 - test wallet
            ), // sample: 0xde0B295669a9FD93d5F28D9Ec85E40f4cb697BAe
            lg02: Yup.mixed().test(
              "is-checked",
              /*eslint-disable no-template-curly-in-string */
              "1st legal block needs to be agreed.",
              value => value.confirmation === true
            ),
            lg03: Yup.mixed().test(
              "is-checked",
              /*eslint-disable no-template-curly-in-string */
              "2nd legal block needs to be agreed.",
              value => value.confirmation === true
            )
          })}
          render={props => (
            <form
              onSubmit={props.handleSubmit}
              className={classes.container}
              name="WalletAddressForm"
            >
              <Typography>
                Please enter your ERC20 compliant wallet address which you will
                use to send ETH and receive CRWD tokens. We need the address to
                whitelist your wallet.
              </Typography>
              <TextField
                name="wallet_address"
                type="text"
                label="Wallet Address"
                className={classes.textField}
                value={props.values.wallet_address}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                error={props.errors.hasOwnProperty("wallet_address")}
                helperText={
                  props.errors.wallet_address && props.touched.wallet_address
                    ? props.errors.wallet_address
                    : " "
                }
              />
              <LegalCheckbox
                name="lg02"
                context={["ico", "erc20 wallet"]}
                defaultState={false}
                setFieldValue={props.setFieldValue}
                value={props.values.lg02}
                error={typeof props.errors.lg02 !== "undefined"}
              >
                MAKE SURE THAT YOU USE AN ERC20 COMPLIANT WALLET.
              </LegalCheckbox>
              <LegalCheckbox
                name="lg03"
                context={["ico", "not from exchange"]}
                defaultState={false}
                setFieldValue={props.setFieldValue}
                value={props.values.lg03}
                error={typeof props.errors.lg03 !== "undefined"}
              >
                DO NOT SEND ETH FROM AN EXCHANGE. If you send ETH to CRWD
                Distribution Contract from an exchange account, your CRWD tokens
                will be allocated to the exchange's ETH account and you may
                never receive or be able to recover your CRWD tokens.
              </LegalCheckbox>
              {/* <FormControlLabel
                style={{ marginBottom: "0.5em" }}
                error={props.errors.lg02}
                classes={
                  props.errors.lg02
                    ? {
                        label: classes.checkboxError
                      }
                    : null
                }
                control={
                  <Checkbox
                    name="lg02"
                    onChange={props.handleChange}
                    checked={props.values.lg02}
                  />
                }
                label="MAKE SURE THAT YOU USE AN ERC20 COMPLIANT WALLET."
              />
              <FormControlLabel
                style={{ alignItems: "start" }}
                error={props.errors.lg03}
                classes={
                  props.errors.lg03
                    ? {
                        label: classes.checkboxError
                      }
                    : null
                }
                control={
                  <Checkbox
                    classes={classes.checkboxLegal}
                    error={props.errors.lg03}
                    name="lg03"
                    onChange={props.handleChange}
                    checked={props.values.lg03}
                  />
                }
                label="DO NOT SEND ETH FROM AN EXCHANGE. If you send ETH to CRWD Distribution Contract from an exchange account, your CRWD tokens will be allocated to the exchange's ETH account and you may never receive or be able to recover your CRWD tokens."
              /> */}
              {this.renderAllErrorMsgs(props.errors)}
              <div className={classes.actionsContainer}>
                <Button
                  onClick={e => {
                    this.handleClickBack(e, props);
                  }}
                  disabled={this.props.step === 0}
                  className={classes.button}
                  type="button"
                >
                  Back
                </Button>
                <Button
                  //type="submit"
                  name="next"
                  color="primary"
                  onClick={e => {
                    this.handleClickNext(e, props);
                  }}
                  variant="outlined"
                  className={classes.button}
                >
                  {this.props.step === this.props.maxsteps - 1
                    ? "Finish"
                    : "Next"}
                </Button>
              </div>
            </form>
          )}
        />
      </div>
    );
  }
}

WalletAdressForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(WalletAdressForm);
